import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faEllipsisV,
	faEdit,
	faTrash,
	faEye,
	faCopy,
} from "@fortawesome/free-solid-svg-icons";
import styles from "./ActionDropdown.module.css";

const ActionDropdown = ({ lecture, onEdit, onDelete }) => {
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef(null);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};

		if (isOpen) {
			document.addEventListener("mousedown", handleClickOutside);
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [isOpen]);

	const handleToggle = (e) => {
		e.stopPropagation();
		setIsOpen(!isOpen);
	};

	const handleAction = (action, lectureId) => {
		setIsOpen(false);
		action(lectureId);
	};

	const handleView = (lectureId) => {
		console.log("View lecture:", lectureId);
	};

	const handleDuplicate = (lectureId) => {
		console.log("Duplicate lecture:", lectureId);
	};

	return (
		<div className={styles.actionDropdown} ref={dropdownRef}>
			<button
				className={styles.moreButton}
				onClick={handleToggle}
				title="More actions"
			>
				<FontAwesomeIcon icon={faEllipsisV} />
			</button>

			{isOpen && (
				<div className={styles.dropdownMenu}>
					<button
						className={styles.dropdownItem}
						onClick={() => handleAction(handleView, lecture.id)}
					>
						<FontAwesomeIcon icon={faEye} className={styles.itemIcon} />
						View Details
					</button>
					<button
						className={styles.dropdownItem}
						onClick={() => handleAction(onEdit, lecture.id)}
					>
						<FontAwesomeIcon icon={faEdit} className={styles.itemIcon} />
						Edit Lecture
					</button>
					<div className={styles.dropdownDivider}></div>
					<button
						className={`${styles.dropdownItem} ${styles.dangerItem}`}
						onClick={() => handleAction(onDelete, lecture.id)}
					>
						<FontAwesomeIcon icon={faTrash} className={styles.itemIcon} />
						Delete
					</button>
				</div>
			)}
		</div>
	);
};

export default ActionDropdown;
